import { SUBSCRIPTION_GET_PAYOUT_TRANSACTIONS } from "../../constants/actions"

const initialState = {
  list: [],
  total: 0,
  success: false,
  message: ""
}

export default (state = initialState, action) => {
  switch (action.type) {
    case SUBSCRIPTION_GET_PAYOUT_TRANSACTIONS:
      return {
        ...state,
        list: action.payload.data || [],
        total: action.payload.data?.length || 0,
        success: action.payload.success,
        message: action.payload.message
      }
    default:
      return state
  }
}
